import { Tag } from "@blueprintjs/core";

export const ABTag: React.FC<{ scenario: "a" | "b" }> = ({ scenario }) => (
    <Tag minimal round intent={scenario === "a" ? "primary" : "warning"}>
        {scenario.toUpperCase()}
    </Tag>
);
